import { Route, Routes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import PrivateRoute from "./PrivateRoute";

//@ts-ignore
import {
  DashboardOverViewBranchRouterService,
  DashboardOverViewMerchantRouterService,
  DashboardOverViewRiderRouterService,
  //@ts-ignore
} from "@careinfo/courier-dashboard-overview";
//@ts-ignore
import { OrderRouterService, TrashOrderRouterService } from "@careinfo/order";
//@ts-ignore
import { WarehouseRouterService } from "@careinfo/warehouse";
//@ts-ignore
import { CustomerRouterService } from "@careinfo/customer";
//@ts-ignore
import { StaffRouterService } from "@careinfo/staff";
//@ts-ignore
import { MerchantRouterService } from "@careinfo/merchant";
//@ts-ignore
import { RiderDriverRouterService } from "@careinfo/rider-driver";
//@ts-ignore
import { SettingsRouterService } from "@careinfo/settings";
//@ts-ignore
import {
  RunsheetRouterService,
  ReturnOrderRouterService,
  ReturnBranchRouterService,
  //@ts-ignore
} from "@careinfo/runsheet";
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from "@careinfo/permission-required";

//@ts-ignore
import { LocationRouterService } from "@careinfo/location";

//@ts-ignore
import { VehicleRouterService } from "@careinfo/vehicle";

//@ts-ignore
import { ProductTypeRouterService } from "@careinfo/product-type";

//@ts-ignore
import { BranchRouterService } from "@careinfo/branch";

//@ts-ignore
import { StatusRouterService } from "@careinfo/status";

//@ts-ignore
import { DeliveryChargeRouterService } from "@careinfo/delivery-charge";

//@ts-ignore
import { ReferenceTypeRouterService } from "@careinfo/reference-type";

//@ts-ignore
import { PaymentMethodRouterService } from "@careinfo/payment-method";

//@ts-ignore
import { ServiceTypeRouterService } from "@careinfo/service-type";
//@ts-ignore
import { PickupRequestRouterService } from "@careinfo/pickup-request-service";
//@ts-ignore
import {
  CourierDispatchManifestService,
  CourierReceiveManifestService,
  //@ts-ignore
} from "@careinfo/manifest";
//@ts-ignore
import {
  BranchInvoiceRouterService,
  MerchantInvoiceRouterService,
  RiderInvoiceRouterRouterService,
  //@ts-ignore
} from "@careinfo/finance-overview";

//@ts-ignore
import { CourierLogisticOverviewRouterService } from "@careinfo/courier-logistic-overview-service";
const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={"/"}
          element={
            <AccessControl
              children={<CourierLogisticOverviewRouterService />}
              allowedPermissions={["can_view_merchant_overview"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/merchant-overview"}
          element={
            <AccessControl
              children={<DashboardOverViewMerchantRouterService />}
              allowedPermissions={["can_view_merchant_overview"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/dispatch-manifest"}
          element={
            <AccessControl
              children={<CourierDispatchManifestService />}
              allowedPermissions={["can_view_manifest"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/receive-manifest"}
          element={
            <AccessControl
              children={<CourierReceiveManifestService />}
              allowedPermissions={["can_view_manifest"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/rider-overview"}
          element={
            <AccessControl
              children={<DashboardOverViewRiderRouterService />}
              allowedPermissions={["can_view_rider_overview"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/branch-overview"}
          element={
            <AccessControl
              children={<DashboardOverViewBranchRouterService />}
              allowedPermissions={["can_view_branch_overview"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/warehouse"}
          element={
            <AccessControl
              children={<WarehouseRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/order"}
          element={
            <AccessControl
              children={<OrderRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/trash-order"}
          element={
            <AccessControl
              children={<TrashOrderRouterService />}
              allowedPermissions={["can_view_consignment"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/customer"}
          element={
            <AccessControl
              children={<CustomerRouterService />}
              allowedPermissions={["can_view_customer"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/staff"}
          element={
            <AccessControl
              children={<StaffRouterService />}
              allowedPermissions={["can_view_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/merchant"}
          element={
            <AccessControl
              children={<MerchantRouterService />}
              allowedPermissions={["can_view_merchant"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/rider"}
          element={
            <AccessControl
              children={<RiderDriverRouterService />}
              allowedPermissions={["can_view_rider"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/settings"}
          element={
            <AccessControl
              children={<SettingsRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/runsheet"}
          element={
            <AccessControl
              children={<RunsheetRouterService />}
              allowedPermissions={["can_view_runsheet"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/return-branch"}
          element={
            <AccessControl
              children={<ReturnBranchRouterService />}
              allowedPermissions={["can_view_rtv_return"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/pickup-request"}
          element={
            <AccessControl
              children={<PickupRequestRouterService />}
              allowedPermissions={["can_view_pickup_request"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/return-orders"}
          element={
            <AccessControl
              children={<ReturnOrderRouterService />}
              allowedPermissions={["can_view_rtv_return"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/vehicle"}
          element={
            <AccessControl
              children={<VehicleRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/address"}
          element={
            <AccessControl
              children={<LocationRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/product-type"}
          element={
            <AccessControl
              children={<ProductTypeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/branch"}
          element={
            <AccessControl
              children={<BranchRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/status-settings"}
          element={
            <AccessControl
              children={<StatusRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/delivery-charge-template"}
          element={
            <AccessControl
              children={<DeliveryChargeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/reference-type"}
          element={
            <AccessControl
              children={<ReferenceTypeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/payment-method"}
          element={
            <AccessControl
              children={<PaymentMethodRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/service-type"}
          element={
            <AccessControl
              children={<ServiceTypeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/finance-rider-invoice"}
          element={
            <AccessControl
              children={<RiderInvoiceRouterRouterService />}
              allowedPermissions={["can_view_rider_invoice"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/finance-merchant-invoice"}
          element={
            <AccessControl
              children={<MerchantInvoiceRouterService />}
              allowedPermissions={["can_view_merchant_invoice"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/finance-branch-invoice"}
          element={
            <AccessControl
              children={<BranchInvoiceRouterService />}
              allowedPermissions={["can_view_branch_invoice"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
